import { Trans, useTranslation } from '@e-kyc/translations';

function CaptureBackOverlay() {
  const { t } = useTranslation();
  return (
    <div className='flex size-full flex-col'>
      <div className='h-[calc((100%-260px)/2)] w-full items-center justify-center' />
      <div className='flex h-[200px] w-full items-center justify-center'>
        <div className='h-full w-[calc((100%-320px)/2)]' />
        <div className='relative h-full w-[320px] rounded-xl shadow-[0_0_0_1000px_rgba(0,0,0,0.5)]'>
          <span className='absolute top-0 left-0 size-8 -translate-x-[2px] -translate-y-[2px] rounded-tl-xl border-t-4 border-l-4 border-white' />
          <span className='absolute top-0 right-0 size-8 translate-x-[2px] -translate-y-[2px] rounded-tr-xl border-t-4 border-r-4 border-white' />
          <span className='absolute bottom-0 left-0 size-8 -translate-x-[2px] translate-y-[2px] rounded-bl-xl border-b-4 border-l-4 border-white' />
          <span className='absolute right-0 bottom-0 size-8 translate-x-[2px] translate-y-[2px] rounded-br-xl border-r-4 border-b-4 border-white' />
        </div>
        <div className='h-full w-[calc((100%-320px)/2)]' />
      </div>
      <div className='z-10 flex w-full grow flex-col items-center justify-start p-4'>
        <h4 className='font-semibold text-white'>{t('capture.overlay.back.title')}</h4>
        <div className='text-body-2 flex flex-col items-center justify-center text-center text-white'>
          <Trans i18nKey='capture.overlay.description' />
        </div>
      </div>
    </div>
  );
}
export default CaptureBackOverlay;
